import { ReactElement, useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { Button, Search } from "@wfp/ui"

import { setPageNumber } from "../../../pages/BaseXlsForm/baseXlsFormSlice"

type Props = {
  onSubmit: (value: string) => void
}

const SearchBox = ({ onSubmit }: Props): ReactElement => {
  const dispatch = useDispatch()

  const [inputText, setInputText] = useState<string>("")

  const handleSearch = (): void => {
    onSubmit(inputText)
    dispatch(setPageNumber(1))
  }

  useEffect(() => {
    if (!inputText) {
      handleSearch()
    }
  }, [inputText])

  return (
    <div className="flex w-full">
      <Search
        id="search"
        placeholder="Search..."
        className="custom-search-field"
        onChange={value => setInputText(value?.toString() || "")}
      />

      <Button onClick={handleSearch} className="ml-1">
        Search
      </Button>
    </div>
  )
}

export default SearchBox
